import ReactDOM from 'react-dom'

import AppContainer from './containers/AppContainer'

ReactDOM.render(<AppContainer />, document.getElementById('root'))
